import { getFunnelTheme } from '@visactor/vchart';

export const funnel3d = getFunnelTheme(true);
